export default __webpack_public_path__ + "static/media/Superman_02.cae17a37.png";